import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./pie-chart-collection.json";
import data from "./pie-chart-data.json";

export const PieChartThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
